export default __webpack_public_path__ + "static/parent-header3-5bb8a279532792b33397e02d4f641d07.png";